import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { BrowserRouter, Route, Switch, HashRouter } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import { Provider } from "react-redux";
import { store } from "./redux/store";
import * as serviceWorker from './serviceWorker';
import AppStore from './Context/AppStore';
import storeRedux from "./Context/ReduxContext";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient();

ReactDOM.render(
  <AppStore>
  <React.StrictMode>
      <HashRouter  >
        {/* <Provider store={store}> */}
        <QueryClientProvider client={queryClient}>
          <Provider store={storeRedux}>
            <App />
          </Provider>
        </QueryClientProvider>
        {/* </Provider> */}
      </HashRouter>
    </React.StrictMode>
  </AppStore>,
  document.getElementById('root')
);
serviceWorker.register()

reportWebVitals();
